import { getFormatLang } from './langs.utils.js';

const formatMoney = (amount = 0, currency = 'EUR', maximumFractionDigits = 2, locale = getFormatLang()) => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits,
    }).format(amount);
};

export { formatMoney };
//# sourceMappingURL=formatMoney.utils.js.map
